import React from "react";
import { Input } from "antd";

export function Filter({ searchText, setSearchText }) {
  return (
    <div className="card mb-3 border-0 shadow-sm">
      <div className="card-body p-3">
        <div className="row align-items-center g-2">
          <div className="col-md-6 col-sm-12">
            <Input
              placeholder="Search by tag name or slug..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              prefix={<i className="la la-search text-muted me-1" />}
              allowClear
            />
          </div>
          <div className="col-md-6 col-sm-12 text-md-end text-muted small">
            <span>Filter tags dynamically by scope or search keywords</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Filter;
